import { FlashNoticeVariant } from 'components/FlashNotice'
import { showFlashNotice } from 'components/FlashNotice/duck/actions'

import { Corporate } from '../../../../../../entities-next/corporate'

export function successfulDeleteAlertAction(corporate: Corporate) {
  return showFlashNotice({
    message: `Corporate with id ${corporate.id} deleted`,
    autoHide: true,
    variant: FlashNoticeVariant.success,
  })
}

export function failedDeleteAlertAction(corporate: Corporate) {
  return showFlashNotice({
    message: `Corporate with id ${corporate.id} could not be deleted`,
    autoHide: true,
    variant: FlashNoticeVariant.error,
  })
}
